export const YAOTAI_MAIN_ORIGIN = 'https://yaotai.163.com';

export function getCurrentMainPortalOrigin() {
  if (window.location.origin === 'https://yaotai-local.portal.danlu.netease.com') {
    return 'https://yaotai-local.portal.danlu.netease.com';
  }
  if (window.location.origin.includes('.163.com')) {
    return YAOTAI_MAIN_ORIGIN;
  }
  if (window.location.origin.includes('.apps-qa.danlu.netease.com')) {
    return 'https://yaotai-portal-qa.apps-qa.danlu.netease.com';
  }
  if (window.location.origin.includes('apps.danlu.netease.com')) {
    return 'https://yaotai-portal-dev.apps.danlu.netease.com';
  }
  return window.location.origin;
}
